'use client';

import clsx from 'clsx';

import { StoryblokStory } from 'storyblok-generate-ts';

import { LocationAccordions } from '../LocationAccordions/LocationAccordions';
import { Map } from '../Map/Map';

import { LocationStoryblok } from '@/types/storyblok/storyblok-types';
import styles from './MapSectionClient.module.scss';

type MapSectionClientProps = {
    locations: StoryblokStory<LocationStoryblok>[];
    isMuliLocationLayout: boolean;
    isDark?: boolean;
};

export const MapSectionClient: React.FC<MapSectionClientProps> = ({ locations, isMuliLocationLayout, isDark }) => (
    <>
        <div className={clsx(styles.root, { [styles.isDark]: isDark })}>
            <div className={clsx('container')}>
                <Map
                    locations={locations}
                    isMuliLocationLayout={isMuliLocationLayout}
                />
            </div>
        </div>
        <div className={clsx('container')}>{isMuliLocationLayout && <LocationAccordions locations={locations} />}</div>
    </>
);
